// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2TfdG","logo":"_1fUEd","listWrapper":"fBw7y","listItem":"kwQa5"};